import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const state = {
  lang: '',
  os: '',
  isShowGnav: false,
  isShowLoading: false,
  links: {},
  note: {},
  urls: {
    fb: 'https://www.facebook.com/FourNines.co.jp',
    insta: 'https://www.instagram.com/999.9_fournines/',
    official: 'https://www.fournines.co.jp/',
    shoplist: 'https://www.fournines.co.jp/shoplist/',
    page: {
      top: '/collections/2020/sunglass/',
      product: {
        sp: '/collections/2020/sunglass/sp/',
        ap: '/collections/2020/sunglass/ap/',
        npm: '/collections/2020/sunglass/npm/'
      }
    }
  }
};

const mutations = {
  setOS(state) {
    const ua = window.navigator.userAgent.toLowerCase();
    if(ua.indexOf("mac os x") !== -1) {
      state.os = 'mac';
    }
  },
  setShowGnav(state, isShow) {
    state.isShowGnav = isShow;
  },
  setShowLoading(state, isShow) {
    state.isShowLoading = isShow;
  }
};

const getters = {
  getLang: (state) => {
    return state.lang;
  },
  getOS: (state) => {
    return state.os;
  },
  isShowGnav: (state) => {
    return state.isShowGnav;
  },
  isShowLoading: (state) => {
    return state.isShowLoading;
  },
  getUrls: (state) => {
    return state.links;
  }
};

export default new Vuex.Store({
  state,
  getters,
  mutations
});